var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSizeMeasure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50391 4.5C3.60848 4.5 4.50391 3.60457 4.50391 2.5C4.50391 1.39543 3.60848 0.5 2.50391 0.5C1.39934 0.5 0.503906 1.39543 0.503906 2.5C0.503906 3.60457 1.39934 4.5 2.50391 4.5Z",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50391 13.4998C3.60848 13.4998 4.50391 12.6043 4.50391 11.4998C4.50391 10.3952 3.60848 9.49976 2.50391 9.49976C1.39934 9.49976 0.503906 10.3952 0.503906 11.4998C0.503906 12.6043 1.39934 13.4998 2.50391 13.4998Z",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.50024C12.6046 4.50024 13.5 3.60481 13.5 2.50024C13.5 1.39567 12.6046 0.500244 11.5 0.500244C10.3954 0.500244 9.5 1.39567 9.5 2.50024C9.5 3.60481 10.3954 4.50024 11.5 4.50024Z",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.5C12.6046 13.5 13.5 12.6046 13.5 11.5C13.5 10.3954 12.6046 9.5 11.5 9.5C10.3954 9.5 9.5 10.3954 9.5 11.5C9.5 12.6046 10.3954 13.5 11.5 13.5Z",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52344 2.46313L9.40215 2.46313",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50391 4.50024L2.50391 9.37896",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.50024L11.5 9.37896",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52344 11.4629L9.40215 11.4629",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSizeMeasure);
export default __webpack_public_path__ + "static/media/ico_size_measure.609da82c538f0600a195f11718db6066.svg";
export { ForwardRef as ReactComponent };